import React, { lazy, Suspense } from 'react';

const LazyProperty = lazy(() => import('./Property'));

const Property = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyProperty {...props} />
  </Suspense>
);

export default Property;
